import { defineComponent as l, ref as r, computed as f, watch as s } from "vue";
import { uniqueId as d } from "lodash-es";
import m from "./td-longtail-vue-components4.js";
import c from "./td-longtail-vue-components3.js";
import O from "./td-longtail-vue-components85.js";
const g = /* @__PURE__ */ l({
  __name: "accordion-item",
  props: {
    isSmall: { type: Boolean, default: !1 },
    isOpen: { type: Boolean, default: !1 },
    isOpenOnDesktop: { type: Boolean, default: !1 },
    role: { default: "region" }
  },
  emits: ["update:isOpen"],
  setup(a, { emit: t }) {
    const o = a, i = r(d()), e = r(o.isOpen), u = f(() => o.isOpenOnDesktop ? !0 : e.value);
    s(
      () => o.isOpen,
      (n) => {
        e.value = n;
      }
    ), s(e, (n) => {
      t("update:isOpen", n);
    });
    const p = () => {
      e.value = !e.value;
    };
    return { __sfc: !0, props: o, emits: t, uid: i, isOpenDerived: e, ariaIsOpen: u, toggleIsOpen: p, handleKeydown: (n) => {
      n.key === "Enter" && p();
    }, Arrow: m, LinkButton: c, TransitionExpand: O };
  }
});
export {
  g as default
};
